import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VarDirective } from './var.directive';
import { ClickStopPropagationDirective } from './stop-propagation.directive';
import { ShowWhenAvailableInConfigDirective } from './show-when-available-in-config.directive';
import { RouterLinkActiveDirective } from './router-link-active.directive';
import { TooltipDirective } from './tooltip.directive';
import { IntercomSpaceButtonDirective } from './intercom-space-button.directive';
import { AddIntercomDataAttributeDirective } from './add-intercom-data-attribute.directive';
import { CheckViewAsOciUserDirective } from './check-view-as-oci-user.directive';
import { ShowWhenRightsDirective } from './show-when-rights.directive';
import { HideWhenAvailableInConfigDirective } from './hide-when-available-in-config.directive';

@NgModule({
    imports: [
        CommonModule,
        VarDirective,
        ClickStopPropagationDirective,
        ShowWhenAvailableInConfigDirective,
        RouterLinkActiveDirective,
        TooltipDirective,
        IntercomSpaceButtonDirective,
        AddIntercomDataAttributeDirective,
        CheckViewAsOciUserDirective,
        ShowWhenRightsDirective,
        HideWhenAvailableInConfigDirective,
    ],
    exports: [
        VarDirective,
        ClickStopPropagationDirective,
        ShowWhenAvailableInConfigDirective,
        RouterLinkActiveDirective,
        TooltipDirective,
        IntercomSpaceButtonDirective,
        AddIntercomDataAttributeDirective,
        CheckViewAsOciUserDirective,
        ShowWhenRightsDirective,
        HideWhenAvailableInConfigDirective
    ]
})
export class CommonDirectivesModule {
}
